const SET_PROFILE = (state, profile) => {
  if (profile && profile.status === 0) {
    state.loggedInUserProfile = undefined;
    return;
  }
  state.loggedInUserProfile = profile;
  if (state.loggedInUserProfile && state.loggedInUserProfile.hasUnreadNotifications) {
    document.title = '🔔 motivac.io ';
  }
};

const SET_USERS = (state, users) => {
  state.users = users;
};

export default {
  SET_PROFILE,
  SET_USERS,
};
